/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_ConfirmInputs */



/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Explorer_Info_Assign_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_confirm = /** @type {((inputs?: Explorer_Info_Assign_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assigner")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zuordnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegnare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配")
	if (locale === "ja") return /** @type {LocalizedString} */ ("割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सौंपना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir")
	return /** @type {LocalizedString} */ ("Assign")
});